import React from 'react';
import { Link } from 'react-router-dom';
import '../css/UserCreationSuccess.css';

function UserCreationSuccess() {
  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">✓</div>
        <h1 className="success-title">Benutzer wurde erfolgreich angelegt!</h1>
        <p className="success-message">
          Das neue Benutzerkonto wurde erfolgreich erstellt.
          Unser System wird den Benutzer mit seinen Anmeldedaten benachrichtigen.
        </p>
        <Link to="/dashboard/users" className="dashboard-button">
          Zurück zum Dashboard
        </Link>
      </div>
    </div>
  );
}

export default UserCreationSuccess;